
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/metal-solutions/industries/packaging-and-processing-equipment",
      function () {
        return require("private-next-pages/metal-solutions/industries/packaging-and-processing-equipment/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/metal-solutions/industries/packaging-and-processing-equipment"])
      });
    }
  